// The answer control for "add pictures to a row" questions (24 Oct 2026,
// Year 1): two buttons for each row to fill, one to add a picture and one
// to take one away. The pictures appear in the graph above
// (PracticeTask.tsx). How many a row has is not printed for the eye:
// counting the pictures is the skill. It is given to screen readers, who
// cannot see the graph.
import {
  FILL_MOST,
  splitFilled,
  stepFilled,
  type BuildPictureGraphQuestion,
} from '../../platform/content/buildPictureGraphAnswer';

type Props = {
  question: BuildPictureGraphQuestion;
  value: string;
  disabled: boolean;
  onChange: (value: string) => void;
};

export function BuildPictureGraphAnswer({
  question,
  value,
  disabled,
  onChange,
}: Props) {
  const counts = splitFilled(value, question);
  return (
    <div className="grid gap-2.5">
      {question.rows.map((row) => {
        const count = counts.get(row.id) ?? row.start;
        return (
          <div
            key={row.id}
            role="group"
            aria-label={`${row.label} row`}
            className="grid grid-cols-2 items-center gap-2 rounded-xl border border-line bg-white px-3 py-2 sm:grid-cols-[1fr_auto_auto]"
          >
            <span className="col-span-2 font-semibold text-forest-950 sm:col-span-1">
              {row.label}
            </span>
            <span role="status" className="sr-only">
              {row.label} row: {String(count)}{' '}
              {count === 1 ? 'picture' : 'pictures'}
            </span>
            <button
              type="button"
              className="dm-btn-secondary min-h-11"
              disabled={disabled || count === 0}
              onClick={() => {
                onChange(stepFilled(value, question, row.id, -1));
              }}
            >
              <span aria-hidden="true">− </span>Take away
            </button>
            <button
              type="button"
              className="dm-btn-secondary min-h-11"
              disabled={disabled || count >= FILL_MOST}
              onClick={() => {
                onChange(stepFilled(value, question, row.id, 1));
              }}
            >
              <span aria-hidden="true">+ </span>Add
            </button>
          </div>
        );
      })}
    </div>
  );
}
